import { KbdProps as MantineKbdProps, Kbd as MantineKbd } from '@mantine/core';

export type KbdProps = MantineKbdProps;

export const Kbd = MantineKbd;

Kbd.displayName = 'Kbd';
